import { HeaderPage, Button, SelectorTipoDescarga } from 'components';
import { MONITOREOS_ESPECTACULARES, ACTA_INICIO } from 'constants/tipoMonitoreos';
import './ActaInicio.scss';
import { Col } from 'antd';
import { FilePdfOutlined } from '@ant-design/icons';
import { BuscadorMonitoreo, TablaMonitoreos } from 'containers/MonitoreoActaInicio';
import { useRef, useState } from 'react';
import pdf from '../../../../assets/Documents/GuiasUsuario/01_Material_Cap_Espectaculares_acta_de_inicio_web_Consultor.pdf';

const nameFile = 'Guía_de_usuario_Espectaculares_acta_de_inicio_web.pdf';

const ActaInicio = () => {
  const [mainFilters, setMainFilters] = useState({});
  const seleccion = useRef({});

  const [procesarTodo, setProcesarTodo] = useState(false);

  const handleDownloadGuia = (documentName) => {
    try {
      if (documentName !== null) {
        const docuName = documentName;
        const link = document.createElement('a');
        link.href = docuName;
        link.download = nameFile;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    } catch (error) {
      console.log('Error', error);
    }
  };

  const handleProcesarTodoChange = (valor) => {
    try {
      setProcesarTodo(valor);
    } catch (error) {
      console.log('Error: ', error);
    }
  };

  return (
    <div className="monitoreos-actaInicio">
      <div className="header-page">
        <Col span={18}>
          <HeaderPage
            section="Monitoreos"
            section2="Espectaculares"
            title="Acta de inicio"
            header="Selecciona al menos un campo para realizar la búsqueda."
          />
        </Col>
        <Button
          text="Descarga la guía"
          icon={<FilePdfOutlined />}
          onClick={() => handleDownloadGuia(pdf)}
        />
      </div>
      <BuscadorMonitoreo onSearch={setMainFilters} />
      <TablaMonitoreos
        mainFilters={mainFilters}
        seleccion={seleccion}
        onProcesarTodoChange={handleProcesarTodoChange}
      />
      <SelectorTipoDescarga
        seleccion={seleccion}
        tipoMonitoreo={MONITOREOS_ESPECTACULARES}
        tipoActa={ACTA_INICIO}
        procesarTodo={procesarTodo}
      />
    </div>
  );
};

export { ActaInicio };
